<template>
  <b-container class="network-item">
    <b-row>
      <b-col class="network-title">
        {{ network.description }} <b-badge>{{ network.region_tag }}</b-badge>
        <b-button variant="link" class="py-0 text-danger" v-on:click="deleteNetwork(network)">
          <font-awesome-icon icon="trash" />
        </b-button>
      </b-col>
      <b-col class="text-sm-right">
        <b-btn variant="success" size="sm" @click="openModal(network.description)" class="mb-2">
          <font-awesome-icon icon="plus" />
          Add node
        </b-btn>
      </b-col>
    </b-row>

    <b-table striped hover :items="network.nodes" :fields="columns" no-sort-reset>
      <template v-slot:cell(provcode)="{ item }">
        <clip-box :node="item" />
      </template>

      <template v-slot:cell(status)="{ item }" class="text-sm-center">
        <font-awesome-icon
          icon="circle"
          :class="{ 'text-success': item.status === '1', 'text-secondary': item.status !== '1' }"
        />
      </template>

      <template v-slot:cell(actions)="{ item }">
        <b-button variant="link" class="p-0 text-danger" v-on:click="deleteNode(item)">
          <font-awesome-icon icon="trash" />
        </b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script type="text/javascript">
import ClipBox from './ClipBox'

export default {
  name: 'Network',
  props: { network: { type: Object, required: true } },

  components: {
    ClipBox
  },

  data: () => ({
    columns: [
      { key: 'status', label: '', sortable: false },
      { key: 'description', label: 'Node', sortable: true },
      { key: 'ipaddress', label: 'IP Address', sortable: true },
      { key: 'provcode', label: 'Provisionning key', sortable: false },
      { key: 'actions', label: '', sortable: false }
    ]
  }),

  methods: {
    resetForm() {
      this.description = ''
    },
    openModal(networkDescription) {
      this.$router.push({ name: 'newNode', params: { networkDescription } })
    },
    deleteNetwork(network) {
      let message = `Delete ${this.network.description} ?`
      let options = {
        okText: 'Yes',
        cancelText: 'No'
      }
      this.$dialog
        .confirm(message, options)
        .then(() => {
          this.$emit('delete-network', network)
          this.$store.dispatch('deleteNetwork', network)
        })
        .catch(() => {
          // console.log('delete cancelled')
        })
    },
    deleteNode(node) {
      let message = `Delete ${node.description} ?`
      let options = {
        okText: 'Yes',
        cancelText: 'No'
      }
      this.$dialog
        .confirm(message, options)
        .then(() => {
          this.$emit('delete-node', node)
          this.$store.dispatch('deleteNode', { node, network: this.network }).catch(() => {})
        })
        .catch(() => {
          // console.log('delete cancelled')
        })
    }
  }
}
</script>
